// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"d7afca52","453":"99737a93"}[chunkId] + ".chunk.js";
};